import ClosingDay from "@/assets/clipart/dashboard/closing-day-banner.svg"
import { Vertical } from "@/components/standard/BFLayout"

export function ClosingDayBanner() {
  return (
    <Vertical>
      <ClosingDay />
    </Vertical>
  )
}
